import { useMemo } from "react";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import { Layout } from "../../components/Layout";
import { useMsg } from "../../components/Msg/Msg";
import { TLTabs } from "../Settings/Tabs";
import { clientsMessages } from "./messages";
import { ClientsTable } from "./ClientsTable";
import { ClientsSessions } from "./ClientsSessions";

const CLIENTS_TABS = {
  CLIENTS: "CLIENTS",
  SESSIONS: "SESSIONS",
};

export function ClientsPage() {
  const msg = useMsg({ dict: clientsMessages });

  const tabs = useMemo(
    () => [
      {
        key: CLIENTS_TABS.CLIENTS,
        visible: true,
        label: msg("clients.tabs.clients.label"),
        Component: ClientsTable,
      },
      {
        key: CLIENTS_TABS.SESSIONS,
        visible: true,
        label: msg("clients.tabs.sessions.label"),
        Component: ClientsSessions,
      },
    ],
    [msg],
  );

  return (
    <Layout header={{ noDivider: true, heading: msg("clients.heading") }}>
      <ErrorBoundary>
        <TLTabs tabs={tabs} />
      </ErrorBoundary>
    </Layout>
  );
}
